module.exports = __webpack_public_path__ + "img/SES_Multiliner_Overview.19d2cb64.jpg";